export default class Patients {
    id: string;
    firstName: string;
    lastName: string;
    age: number;
    gender: string;
    bloodType: string;
    phoneNumber: string;
    email: string;
    nextAppointment: string;
    lastExam: { type: string; date: string } | null;

    constructor(
        id: string,
        firstName: string,
        lastName: string,
        age: number,
        gender: string,
        bloodType: string,
        phoneNumber: string,
        email: string,
        nextAppointment: string,
        lastExam: { type: string; date: string } | null = null
    ) {
        this.id = id;
        this.firstName = firstName;
        this.lastName = lastName;
        this.age = age;
        this.gender = gender;
        this.bloodType = bloodType;
        this.phoneNumber = phoneNumber;
        this.email = email;
        this.nextAppointment = nextAppointment;
        this.lastExam = lastExam;
    }
}
